import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Calendar } from 'lucide-react';
import { SHEET_ANIMATION, BACKDROP_ANIMATION } from './sheetAnimationConfig';
/**
 * SeasonSheet - Bottom sheet for selecting season/year
 * Can be used for any sport that has seasonal data
 */
const SeasonSheet = ({ 
  isOpen, 
  onClose, 
  currentSeason, 
  onSeasonChange,
  availableSeasons = [],
  sport = 'baseball' 
}) => {
  // Generate default seasons if none provided
  const seasons = availableSeasons.length > 0 ? availableSeasons : (() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= currentYear - 5; year--) {
      years.push(year);
    }
    return years;
  })();

  const handleSeasonSelect = (season) => {
    onSeasonChange(season);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            {...BACKDROP_ANIMATION}
            className="fixed inset-0 bg-black/50 z-40"
            onClick={onClose}
          />
          
          {/* Sheet */}
          <motion.div
            {...SHEET_ANIMATION}
            className="fixed bottom-0 left-0 right-0 bg-gray-900 rounded-t-2xl z-50 max-h-[50vh] overflow-hidden"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-800">
              <h3 className="text-lg font-semibold text-white">Select Season</h3>
              <button
                onClick={onClose}
                className="p-1 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>
            
            {/* Season List */}
            <div className="p-2 overflow-y-auto max-h-[calc(50vh-80px)]">
              <div className="grid grid-cols-2 gap-2">
                {seasons.map((season) => {
                  const isSelected = currentSeason === season;
                  const isCurrentYear = season === new Date().getFullYear();
                  
                  return (
                    <button
                      key={season}
                      onClick={() => handleSeasonSelect(season)}
                      className={`
                        p-3 rounded-lg transition-all flex items-center justify-center gap-2
                        ${isSelected 
                          ? 'bg-blue-500/20 border border-blue-500/50 text-blue-400' 
                          : 'bg-gray-800/50 hover:bg-gray-800 text-white'
                        }
                      `}
                    >
                      <Calendar className="w-4 h-4 opacity-60" />
                      <span className="font-medium">{season}</span>
                      {isCurrentYear && (
                        <span className="text-xs px-1.5 py-0.5 bg-blue-500/20 text-blue-400 rounded">
                          Current
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SeasonSheet;